import React from 'react';
import { Loader2 } from 'lucide-react';

const VARIANT_CLASSES = {
  primary: 'bg-blue-600 hover:bg-blue-700 text-white border-blue-600',
  danger: 'bg-rose-600 hover:bg-rose-700 text-white border-rose-600',
  success: 'bg-emerald-600 hover:bg-emerald-700 text-white border-emerald-600',
};

export default function ApiButton({
  loading = false,
  onClick,
  children,
  variant = 'primary',
  className = '',
  disabled = false,
  type = 'button',
  ...rest
}) {
  const isDisabled = loading || disabled;
  const variantClass = VARIANT_CLASSES[variant] || VARIANT_CLASSES.primary;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={isDisabled}
      {...rest}
      className={`inline-flex items-center justify-center gap-2 rounded-lg border px-4 py-2.5 font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-60 ${variantClass} ${className}`}
    >
      {loading && <Loader2 size={16} className="animate-spin" />}
      {children}
    </button>
  );
}
